import React, { useState } from 'react';
import { motion } from 'framer-motion';

const OTPVerification = ({ type, onVerify, onCancel }) => {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await onVerify(otp);
    } catch (err) {
      setError(err.message || 'Invalid OTP code');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4 backdrop-blur-sm">
      <motion.div
        initial={{ scale: 0.95, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className="card-glass w-full max-w-md rounded-3xl border border-white/10 p-8 shadow-[0_18px_60px_rgba(0,0,0,0.5)]"
      >
        <h2 className="text-2xl font-semibold tracking-tight text-white mb-2">
          {type === 'login' ? 'Login verification' : 'Withdrawal verification'}
        </h2>
        <p className="text-sm text-stone-400 mb-6">
          {type === 'login'
            ? 'Enter your login OTP to access your account.'
            : 'Enter your withdrawal OTP to process your withdrawal.'}
        </p>

        {error && (
          <div className="mb-4 rounded-xl border border-rose-400/25 bg-rose-500/10 p-4">
            <p className="text-sm text-rose-200">{error}</p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="otp" className="block text-sm font-medium text-stone-300">
              {type === 'login' ? 'Login OTP' : 'Withdrawal OTP'}
            </label>
            <input
              type="text"
              id="otp"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              className="input-glass mt-1 block w-full placeholder:text-stone-500"
              placeholder="Enter your OTP code"
              required
            />
          </div>

          <div className="flex gap-3">
            <motion.button
              type="submit"
              disabled={loading}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="flex-1 rounded-xl bg-cyan-400 py-2.5 px-4 text-sm font-semibold text-slate-950 hover:bg-cyan-300 disabled:opacity-50"
            >
              {loading ? 'Verifying...' : 'Verify OTP'}
            </motion.button>
            <motion.button
              type="button"
              onClick={onCancel}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="flex-1 rounded-xl border border-white/15 bg-white/5 py-2.5 px-4 text-sm font-semibold text-stone-100 hover:bg-white/10"
            >
              Cancel
            </motion.button>
          </div>
        </form>
      </motion.div>
    </div>
  );
};

export default OTPVerification;
